<template>
  <div
    class="controlItemWrapper filesControl"
    :class="control.className"
    :data-control-name="control.name"
  >
    <div class="controlItem row" :id="control.name" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}} 123</label>
      </div>
      <div class="col-md-8">
        <ul v-if="cellDisplayVal">
          <li v-for="file of cellDisplayVal" :key="file.key">
            <b-badge :href="file.url" target="_blank" variant="success">{{ file.name }}</b-badge>
          </li>
        </ul>
      </div>
    </div>
    <div class="controlItem row" :id="control.name" v-else>
      <div class="form-group col-md-12">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
        <div>
          <ul v-if="cellDisplayVal">
            <li v-for="file of cellDisplayVal" :key="file.key">
              <b-badge :href="file.url" target="_blank" variant="success">{{ file.name }}</b-badge>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['control', 'labelPosition'],
  data() {
    return {
      gridId: null,
      rowKey: null,
      cellKey: null,
    }
  },
  computed: {
    cellDisplayVal() {
      if (!this.gridId || !this.rowKey || !this.cellKey) return null

      return $dataGrid(this.gridId)[this.rowKey][`$${this.cellKey}$display`]
    },
  },
  created() {
    this.$nextTick(() => {
      const formBuilderInst = this.$instByClass(this, 'form-builder-root')
      this.gridId = formBuilderInst.gridId
      this.rowKey = formBuilderInst.rowKey
      this.cellKey = this.control.propName
    })
  },
}
</script>

<style lang="scss">
@import '~$scss/globals';

.filesControl {
  ul {
    @include resetList;
    li {
      margin-bottom: 3px;
    }
  }
  &._delete:hover {
    color: #fb6340;
  }
}
</style>
